import { enumC } from '@mxt/zio/codec'

export enum TopupOption {
  Ratio = 'Ratio',
  Amount = 'Amount'
}
export const TopupOptionC = enumC(TopupOption)
